module.exports = __webpack_public_path__ + "025d8afe675c559eafe822eb4dc03fd9.MP3";